import { render, staticRenderFns } from "./_UserTeaser.vue?vue&type=template&id=984e1198&scoped=true&"
import script from "./_UserTeaser.vue?vue&type=script&lang=js&"
export * from "./_UserTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984e1198",
  null
  
)

export default component.exports